import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Drag-and-drop list. Persist the new id order with PATCH on drop.
//
//   data-controller="sortable"
//   data-sortable-url-value="/content/forms/profile/order"
//   data-sortable-target="item" data-id="..."
//   data-sortable-target="handle" on the grip only
export default class extends Controller {
  static targets = ["item", "handle"]
  static values = { url: String }

  connect() {
    this.abortController = new AbortController()
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      draggable: "[data-sortable-target='item']",
      handle: this.hasHandleTarget ? "[data-sortable-target='handle']" : undefined,
      ghostClass: "opacity-50",
      forceFallback: true,
      fallbackOnBody: true,
      fallbackTolerance: 3,
      delayOnTouchOnly: true,
      delay: 150,
      onEnd: () => this.persist()
    })
  }

  disconnect() {
    this.abortController?.abort()
    this.sortable?.destroy()
  }

  async persist() {
    if (!this.hasUrlValue) return

    this.element.dataset.sortableStatus = "saving"
    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken
        },
        body: JSON.stringify({ ids: this.itemTargets.map((item) => item.dataset.id) }),
        signal: this.abortController.signal
      })
      this.element.dataset.sortableStatus = response.ok ? "saved" : "failed"
    } catch (error) {
      if (error.name === "AbortError") return

      console.error("Failed to persist sort order", error)
      this.element.dataset.sortableStatus = "failed"
    }
  }

  get csrfToken() {
    return document.querySelector("meta[name='csrf-token']")?.content || ""
  }
}
